import React from "react";
import { Alert } from "antd";
import { FormattedMessage } from "react-intl";

const NonEuWarning = () => (
  <Alert
    closable
    type="warning"
    message={
      <FormattedMessage
        id="calculator.address.warning"
        defaultMessage="Cena neobsahuje celní poplatky (nakládka nebo vykládka mimo EU)."
      />
    }
  />
);

export default NonEuWarning;
